import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Mobile-browser camera QR scanner. Resolves the decoded token via onScan.
export default function QrScanner({ open, onScan, onClose, onFallback, allowFallback }) {
  const doneRef = useRef(false);
  const scannerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    doneRef.current = false;
    let h;
    const t = setTimeout(() => {
      try {
        h = new Html5Qrcode("att-qr-reader");
        scannerRef.current = h;
        h.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 },
          (decoded) => {
            if (doneRef.current) return;
            doneRef.current = true;
            h.stop().then(() => h.clear()).catch(() => {}).finally(() => onScan(decoded));
          }, () => {}).catch(() => {});
      } catch { /* camera unavailable */ }
    }, 150);
    return () => {
      clearTimeout(t);
      try {
        const s = scannerRef.current;
        if (s && s.getState && s.getState() === 2) s.stop().then(() => s.clear()).catch(() => {});
      } catch { /* noop */ }
    };
  }, [open, onScan]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="att-qr-scanner">
        <DialogHeader><DialogTitle>Scan Office QR</DialogTitle>
          <DialogDescription>Point your camera at the office attendance QR screen. It refreshes periodically — scan the current code.</DialogDescription></DialogHeader>
        <div id="att-qr-reader" className="w-full rounded overflow-hidden bg-slate-100" style={{ minHeight: 260 }} />
        <p className="text-[11px] text-slate-400 text-center">Keep location enabled for full verification. The office code refreshes periodically — scan the one on screen now.</p>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={onClose} data-testid="att-qr-cancel">Cancel</Button>
          {allowFallback && <Button variant="outline" className="flex-1 border-amber-400 text-amber-700" onClick={onFallback} data-testid="att-qr-fallback">Can't scan — request exception</Button>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
